import { Ref, ref, computed } from "@vue/composition-api";
import { ApiResult } from "../api/ApiResult.model";

export interface UseFiniteCollectionOutput<T, A> {
  is_loading: Ref<boolean>;
  items: Ref<T[]>;
  clear: () => void;
  has_no_results: Readonly<Ref<Readonly<boolean>>>;
  load_items: (a: A) => Promise<void>;
}

export const UseFiniteCollection = <T, A>(
  api_call: (a: A) => Promise<ApiResult<T[]>>
): UseFiniteCollectionOutput<T, A> => {
  const is_loading = ref(false);
  const items: Ref<T[]> = ref([]);
  const _has_no_results = ref(false);
  const has_no_results = computed(() => _has_no_results.value);

  const load_items = async (a: A) => {
    is_loading.value = true;
    const res = await api_call(a);
    if (res.success) {
      items.value = res.value;
      _has_no_results.value = items.value.length === 0;
    }
    is_loading.value = false;
  };

  const clear = () => {
    items.value = [];
    _has_no_results.value = false;
  };

  return {
    is_loading,
    items,
    clear,
    load_items,
    has_no_results,
  };
};
